module.exports = "/images/oculus-2.jpg";